import React from "react";
import classes from "./Chat.module.css";

type Props = {
  isOpen: boolean;
  onAccept: () => void;
  onClose: () => void;
};

const ChatConsentModal = ({ isOpen, onAccept, onClose }: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={classes.termsOverlay} role="presentation">
      <div
        className={classes.termsDialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="chat-terms-title"
      >
        <div className={classes.termsDialogHeader}>
          <h2 id="chat-terms-title" className={classes.termsTitle}>
            Terms and conditions
          </h2>
          <p className={classes.termsDescription}>
            Before opening the assistant, please review the applicable terms and
            privacy information.
          </p>
        </div>

        <div className={classes.termsLinks}>
          <a
            className={classes.termsLinkCard}
            href="https://pnoe.com/tcs/"
            target="_blank"
            rel="noreferrer"
          >
            <span className={classes.termsLinkTitle}>Terms and conditions</span>
            <span className={classes.termsLinkUrl}>pnoe.com/tcs/</span>
          </a>
          <a
            className={classes.termsLinkCard}
            href="https://pnoe.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            <span className={classes.termsLinkTitle}>Privacy policy</span>
            <span className={classes.termsLinkUrl}>
              pnoe.com/privacy-policy/
            </span>
          </a>
        </div>

        <p className={classes.termsFootnote}>
          By continuing, you confirm that you have reviewed these documents and
          want to proceed to the assistant experience.
        </p>

        <div className={classes.termsActions}>
          <button
            type="button"
            className={classes.termsSecondaryButton}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className={classes.termsPrimaryButton}
            onClick={onAccept}
          >
            I agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatConsentModal;
